import { NetworkApi } from 'network';
import { Import } from '../pages/EscrowImports/Details/types';

export type ImportType = 'DESTINATION' | 'TRANSFER';

export type ImportStatus = 'PENDING' | 'PROCESSING' | 'ERROR' | 'FINISHED';

export interface ImportItem {
	id: string;
	type: 'DESTINATION' | 'TRANSFER';
	status: ImportStatus;
	created_at: string;
	updated_at: string;
	lines_processed: number;
	total_lines: number;
}

export interface ImportDetails extends ImportItem {
	records: {
		data: any;
		status: 'SUCCESS' | 'ERROR';
		error?: string;
	}[];
}

export class ImportsService extends NetworkApi {
	public static getImports(params: { type: ImportType; accountId: string }) {
		return this.get<ImportItem[]>(`/imports/type/${params.type}`, {
			accountId: params.accountId,
		});
	}

	public static createImport(payload: {
		file: File;
		type: 'destination' | 'transfer';
		accountId: string;
	}) {
		const formData = new FormData();

		formData.append('file', payload.file);
		formData.append('type', payload.type);

		return this.post<{ id: string }, FormData, void>(
			`/accounts/${payload.accountId}/imports`,
			formData,
		);
	}

	public static getImport(importId: string) {
		return this.get<Import>(`/imports/${importId}`);
	}

	public static getTransferFile(importId: string) {
		return this.get<{ url: string }>(`/imports/${importId}/transfer-file`);
	}

	public static getReturnFile(importId: string) {
		return this.get<{ url: string }>(`/imports/${importId}/return-file`);
	}
}
